import React from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Subscription.module.scss';
const DiscountIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47 47",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#262626",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.352",
  d: "M16.714 16.948h.022M29.95 30.185h.022m2.184-15.443L14.507 32.39M36.352 8.12a4.484 4.484 0 0 0 2.425 2.428l3.85 1.595a4.484 4.484 0 0 1 2.427 5.859l-1.594 3.847a4.477 4.477 0 0 0 .002 3.434l1.59 3.847a4.485 4.485 0 0 1-2.427 5.86l-3.848 1.595a4.484 4.484 0 0 0-2.428 2.424l-1.594 3.85a4.484 4.484 0 0 1-5.86 2.427l-3.847-1.593a4.484 4.484 0 0 0-3.43.002l-3.851 1.593a4.484 4.484 0 0 1-5.855-2.426l-1.596-3.851a4.484 4.484 0 0 0-2.424-2.428l-3.85-1.595a4.484 4.484 0 0 1-2.428-5.857l1.593-3.847a4.485 4.485 0 0 0-.002-3.431L1.612 18a4.485 4.485 0 0 1 2.428-5.862l3.848-1.593a4.484 4.484 0 0 0 2.426-2.422l1.595-3.85a4.485 4.485 0 0 1 5.86-2.427l3.847 1.593a4.484 4.484 0 0 0 3.43-.002l3.852-1.589a4.484 4.484 0 0 1 5.859 2.427l1.595 3.851V8.12Zm-18.534 8.828a1.103 1.103 0 1 1-2.206 0 1.103 1.103 0 0 1 2.206 0Zm13.237 13.237a1.103 1.103 0 1 1-2.206 0 1.103 1.103 0 0 1 2.206 0Z",
  style: {
    mixBlendMode: 'multiply'
  }
}));
const DeliveryIcon = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "81",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 40.453c0-22.092 17.909-40 40-40s40 17.908 40 40c0 22.091-17.909 40-40 40s-40-17.909-40-40Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#262626",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.359",
  d: "M43.366 32.423a7.704 7.704 0 1 1 2.071-10.353M26.794 58.253h5.746c.749 0 1.493.09 2.22.268l6.07 1.475a9.41 9.41 0 0 0 4.02.093l6.713-1.305a9.255 9.255 0 0 0 4.683-2.438l4.748-4.62a3.309 3.309 0 0 0 0-4.773 3.544 3.544 0 0 0-4.535-.315l-5.535 4.038a4.659 4.659 0 0 1-2.75.892H42.83h3.402c1.918 0 3.47-1.511 3.47-3.377v-.675c0-1.548-1.083-2.899-2.627-3.273l-5.25-1.277a11.062 11.062 0 0 0-2.61-.312c-2.123 0-5.967 1.758-5.967 1.758l-6.454 2.699M57.61 28.347a7.704 7.704 0 1 1-15.408 0 7.704 7.704 0 0 1 15.407 0Zm-39.62 17.828v12.767c0 1.233 0 1.849.24 2.32a2.2 2.2 0 0 0 .962.962c.47.24 1.087.24 2.32.24h1.76c1.233 0 1.85 0 2.32-.24a2.2 2.2 0 0 0 .962-.962c.24-.471.24-1.087.24-2.32V46.175c0-1.232 0-1.849-.24-2.32a2.2 2.2 0 0 0-.962-.961c-.47-.24-1.087-.24-2.32-.24h-1.76c-1.233 0-1.85 0-2.32.24a2.2 2.2 0 0 0-.962.962c-.24.47-.24 1.087-.24 2.32Z",
  style: {
    mixBlendMode: 'multiply'
  }
}));
const getIconForHeading = heading => {
  var _heading$toLowerCase, _heading$toLowerCase2;
  const normalized = (_heading$toLowerCase = heading === null || heading === void 0 ? void 0 : (_heading$toLowerCase2 = heading.toLowerCase) === null || _heading$toLowerCase2 === void 0 ? void 0 : _heading$toLowerCase2.call(heading)) !== null && _heading$toLowerCase !== void 0 ? _heading$toLowerCase : '';
  if (normalized.includes('-20%') || normalized.includes('20% taniej')) {
    return DiscountIcon;
  }
  if (normalized.includes('dostawa') && normalized.includes('gratis')) {
    return DeliveryIcon;
  }
  return null;
};
const Subscription = ({
  heading,
  items,
  cta
}) => {
  if (!(items !== null && items !== void 0 && items.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, heading && /*#__PURE__*/React.createElement("h2", {
    className: styles.rootHeading,
    dangerouslySetInnerHTML: {
      __html: heading
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootGrid
  }, items.map(({
    heading: itemHeading,
    icon: itemIconName,
    text
  }, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles.rootItem
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.rootItemIcon
    }, /*#__PURE__*/React.createElement(Icon, {
      name: itemIconName,
      size: {
        width: 80,
        height: 80
      }
    })), /*#__PURE__*/React.createElement("h3", {
      className: styles.rootItemTitle,
      dangerouslySetInnerHTML: {
        __html: itemHeading
      }
    }), /*#__PURE__*/React.createElement("p", {
      className: styles.rootItemText,
      dangerouslySetInnerHTML: {
        __html: text
      }
    }));
  })), (cta === null || cta === void 0 ? void 0 : cta.label) && /*#__PURE__*/React.createElement("div", {
    className: styles.rootCta
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootCtaLink,
    href: cta.href || '#'
  }, cta.label))));
};
export default Subscription;